import { Link } from "react-router"
import "../assents/styles/components/Navbar.scss"
export default function Nabvar(){
    return(
        <nav className="navbar">
                <a className="navbar__list--link"> 
                    <Link to="/home">About me</Link>
                </a>
                <a>
                    <Link to="/">Projects Demo</Link>
                </a>
                <a>
                    <Link to="/contact">Contact</Link>
                </a>
        </nav>
    )
}